import request from '@/utils/request'

export function getQueryFormulaInfo(id, activityId) {
  return request({
    url: `/templates/${id}/queryformulas`,
    method: 'get',
    params: {
      app: 1,
      activityId: activityId || 0
    }
  })
}

export function getQueryFormulaOutput(templateId, queryId, data) {
  return request({
    url: `/queryformulas/${queryId}/invoke?templateId=${templateId}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
